<template>
  <footer class="footer pt-1 pb-1 unselectable">
    <div class="container my-auto">
    <div class="text-center">
      <span class="mr-2">💞 gender app {{new Date().getFullYear()}}</span>·
      <a class="m-2 fab fa-instagram" href="https://instagram.com/gender_app" target="_blank" ></a>
      <a class="m-2 fab fa-facebook" href="https://www.facebook.com/genderapp" target="_blank" ></a>
      <a class="m-2 fab fa-patreon" href="https://www.patreon.com/genderapp" target="_blank" ></a>
    </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'GenderAppFooter'
}
</script>

<style scoped>
</style>
